import axios from "axios";
import { apiURL } from './api.js';

// Function to subscribe to newsletter
export const subscribeNewsletter = async (email, role, isAcceptedPolicy) => {
    try {
        if (!email) {
            throw new Error('Email is required');
        }

        const payload = {
            email,
            role,
            is_accepted_policy: isAcceptedPolicy
        };
        
        const response = await axios.post(`${apiURL}/newsletter/subscribe`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (response.status !== 200 && response.status !== 201) {
            throw new Error('Failed to subscribe to newsletter');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error subscribing to newsletter:', error);
        throw error;
    }
};
